
      // Bootstrap app only after handling SW to avoid stale-cache JS parse errors in dev.
      (function () {
        const isDevelopment =
          window.location.hostname === 'localhost' ||
          window.location.hostname === '127.0.0.1' ||
          window.location.port === '5173';

        const loadApp = async () => {
          if (window.__unmaHardRedirect) return;
          // Import app entry in a Vite-compatible way so production builds rewrite it to hashed assets.
          await import('/src/main.jsx');
        };

        if (!('serviceWorker' in navigator)) {
          loadApp();
          return;
        }

        // In development the service worker caches Vite's dev assets and breaks HMR:
        // a normal refresh serves a cached page with a stale HMR token, so the websocket
        // fails ("WebSocket closed without opened"). Unregister any existing worker and
        // clear caches, and never register it in dev. Production keeps the SW.
        if (isDevelopment) {
          navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => Promise.all(registrations.map((r) => r.unregister())))
            .catch(() => {});
          if (window.caches && caches.keys) {
            caches
              .keys()
              .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
              .catch(() => {});
          }
          loadApp();
          return;
        }

        const registerServiceWorker = () => {
          navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
              registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (!newWorker) return;
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    // New worker is waiting; the app applies it after splash.
                  }
                });
              });
            })
            .catch(() => {});
        };

        window.addEventListener('load', registerServiceWorker);

        loadApp();
      })();
    